import {store} from '../config/store';
import {navigateByHistory} from '../action/actions';

class History {
    constructor() {
        this.register();
    }

    push = (page) => {
        window.history.pushState({
            page,
        }, '', page);
    };

    static pop = (event) => {
        let {state: {page = 0}} = event;

        store.dispatch(navigateByHistory(page));
    }

    register = () => window.onpopstate = History.pop;
}

export default new History();
